__turbopack_context__.v({
  "analystRatingGaugeContainer": "AnalystRatingsCharts-module-scss-module__XKZ_9W__analystRatingGaugeContainer",
  "colorKeyWrapper": "AnalystRatingsCharts-module-scss-module__XKZ_9W__colorKeyWrapper",
});
